export function testIdCard(cardid) {
  //身份证正则表达式(18位)
  let isIdCard2 = /^[1-9]\d{5}(19\d{2}|[2-9]\d{3})((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])(\d{4}|\d{3}X)$/i;
  let stard = "10X98765432"; //最后一位身份证的号码
  let first = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //1-17系数
  let sum = 0;
  if (!isIdCard2.test(cardid)) {
      return false;
  }
  let year = cardid.substring(6, 10);
  let month = cardid.substring(10, 12);
  let day = cardid.substring(12, 14);
  let birthday = cardid.substring(6, 14);
  if (birthday != dateToString(new Date(year + '/' + month + '/' + day))) { //校验日期是否合法
      return false;
  }
  for (let i = 0; i < cardid.length - 1; i++) {
      sum += cardid[i] * first[i];
  }
  let result = sum % 11;
  let last = stard[result]; //计算出来的最后一位身份证号码;
  if (cardid[cardid.length - 1].toUpperCase() == last) {
      return true;
  } else {
      return false;
  }
};
export function calculateAge(idNo){
//获取年龄
var myDate = new Date();
var month = myDate.getMonth() + 1;
var day = myDate.getDate();
var age = myDate.getFullYear() - idNo.substring(6, 10) - 1;
if (idNo.substring(10, 12) < month || idNo.substring(10, 12) == month && idNo.substring(12, 14) <= day) {
  age++;
}
return age
}
 //日期转字符串 返回日期格式20080808
 function dateToString(date) {
  if (date instanceof Date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? '0' + month: month;
      let day = date.getDate();
      day = day < 10 ? '0' + day: day;
      return year +""+ month +""+ day;
  }
  return '';
}
export function packPromise(promise){
    return promise.then(res=>{
      return [null,res]
    }).catch(err=>{
      return [err,{data:null}]
    })
  }



// WEBPACK FOOTER //
// ./src/utils/index.js